import * as React from 'react';

type Omit<T, U extends keyof T> = Pick<T, Exclude<keyof (T), U>>;
type ImgProps = Omit<React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>, "height" | "width">;
export default class Img extends React.Component<ImgProps> {
    render() {
        if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
            return this.renderIE10();
        }
        return this.renderOthers();
    }
    renderIE10() {
        const hasStyleWidth = this.props.style ? "width" in this.props.style : false;
        const hasStyleHeight = this.props.style ? "height" in this.props.style : false;
        const width = hasStyleWidth ? this.props.style!.width : undefined;
        const height = hasStyleHeight ? this.props.style!.height : undefined;
        return <img width={width} height={height} {...this.props} />
    }
    renderOthers() {
        return <img {...this.props} />
    }
}